import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import UIGlobalStyles from '@lt/components/styles/styles';
import ErrorBoundary from 'src/error/components/ErrorBoundary';

import Layout from 'src/components/Layout';
import LazySeamlessTBankAuth from 'src/components/SeamlessTBankAuth';
import { setPageColors } from 'src/hooks/setPageColors';
import { getStore } from './store';

import SearchPage from './components/SearchPage';
import { MODULE_NAME } from '../../constants';

interface ISearchPageApp {
  searchType?: string;
  isWhitelabel?: boolean;
  wlPartnerSettings?: any;
}

const SearchPageApp = (props: ISearchPageApp) => {
  const { searchType, isWhitelabel, wlPartnerSettings } = props;

  if (!searchType) {
    // TODO: Я бы тут реализовал модальное окно, которое будет выводить ошибку
    // eslint-disable-next-line no-console
    console.error('Поле searchType не объявлено');
  }

  try {
    if (isWhitelabel && wlPartnerSettings)
      setPageColors({
        primary: wlPartnerSettings.primary,
        primaryColor: wlPartnerSettings.primaryColor,
        primaryHeader: wlPartnerSettings.primaryHeader,
        primaryHeaderColor: wlPartnerSettings.primaryHeaderColor,
        secondary: wlPartnerSettings.secondary,
        secondaryColor: wlPartnerSettings.secondaryColor,
        secondaryHeader: wlPartnerSettings.secondaryHeader,
        secondaryHeaderColor: wlPartnerSettings.secondaryHeaderColor,
        background: wlPartnerSettings.background,
      });
  } catch (e) {
    console.log(e);
  }

  return (
    <ErrorBoundary>
      <Provider store={getStore(props)}>
        <UIGlobalStyles />
        <UserflowTheme>
          <Layout appName={MODULE_NAME.SEARCH}>
            <>
              <SearchPage />
              <LazySeamlessTBankAuth />
            </>
          </Layout>
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

export default SearchPageApp;
